import React, { useEffect, useState } from "react";
import {
  AppContent,
  AppSidebar,
  AppFooter,
  AppHeader,
} from "../components/index";
import { useLocation } from "react-router-dom";
import Loader from "src/components/loader/Loader";
import { useRecoilState } from "recoil";
import { loadingState, alertMessageState } from "src/atom/LoadingState";
import { validate } from "../Services/Login/LoginService";
import _nav from "src/_nav";
import routes from "src/routes";
import { AlertComponent } from "src/components/AlertComponent";

const DefaultLayout = () => {
  const location = useLocation();
  const [loading, setLoading] = useRecoilState(loadingState);
  const [alertMessage, setAlertMessage] = useRecoilState(alertMessageState);
  const [filteredNavs, setFilteredNavs] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token && location.pathname !== "/#/login") {
      window.location.href = "/#/login";
      return;
    }
    validateUser();
  }, [location.pathname]);

  const handleCloseAlert = () => {
    setAlertMessage("");
  };

  const validateUser = async () => {
    const validateResponse = await validate();
    if (!validateResponse.success) {
      localStorage.clear();
      window.location.href = "/#/login";
      return;
    }
    navFilteration(validateResponse.data.role);
    routeAuthorization(validateResponse.data.role);
  };

  const navFilteration = (role) => {
    if (filteredNavs.length === 0) {
      setFilteredNavs(
        _nav.filter((route) => isRouteisAccessible(route?.to, role))
      );
    }
  };

  const routeAuthorization = (role) => {
    if (!isRouteisAccessible(location.pathname, role)) {
      window.location.href = "/#/404";
    }
  };

  const isRouteisAccessible = (route, role) => {
    if (
      routes.find((value) => value.path === route && value.roles.includes(role))
    ) {
      return true;
    }
    return false;
  };

  return (
    <div>
      <AppSidebar filteredNavs={filteredNavs} />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <AlertComponent message={alertMessage} onClose={handleCloseAlert} />
        <div className="body flex-grow-1 px-3">
          <AppContent />
          {loading ? <Loader></Loader> : <></>}
        </div>
        <AppFooter />
      </div>
    </div>
  );
};

export default DefaultLayout;
